/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import React, { Component, PropsWithChildren } from 'react';
import { Result } from 'antd';

import { isIEMessage } from '@/utils/isIEMessage';

// 用于捕获渲染时错误的组件

class ErrorBoundary extends Component<PropsWithChildren> {
  state = {
    error: null,
  };

  static getDerivedStateFromError(error: unknown): unknown {
    return { error };
  }

  render(): React.ReactNode {
    isIEMessage();

    if (this.state.error) {
      return (
        <Result
          status="error"
          title="哎呀, 加载出错啦!"
          subTitle="大事不妙啦！你访问的页面好像被玩坏了~"
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
